import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { navRoutes } from "routes/routes";

export const MobileMenu = ({
	countriesList,
	flag,
	text,
	handleOnClick,
	handleOnSelectChange,
	activeSection,
}) => {
	const intl = useIntl();
	const [isOpen, setIsOpen] = useState(false);
	const [changeIcon, setChangeIcon] = useState(false);

	useEffect(() => {
		const html = document.querySelector("html");
		const body = document.querySelector("body");

		if (isOpen) {
			setTimeout(() => {
				html.classList.add("block-scroll");
				body.classList.add("block-scroll");
				setChangeIcon(isOpen);
			}, 300);
		} else {
			setTimeout(() => {
				html.classList.remove("block-scroll");
				body.classList.remove("block-scroll");
				setChangeIcon(isOpen);
			}, 350);
		}
	}, [isOpen]);

	return (
		<div className="block xl:hidden mr-4 relative">
			<button
				className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-surface-100 transition-colors"
				onClick={() => setIsOpen(!isOpen)}
				aria-label={changeIcon ? "Cerrar menú" : "Abrir menú"}
			>
				{changeIcon ? (
					<svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
					</svg>
				) : (
					<svg className="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
					</svg>
				)}
			</button>
			<div
				className={`m-h-screen w-screen bg-white z-30 fixed ${
					isOpen ? "left-0" : "left-full"
				} bottom-0 top-[62px] flex flex-col transition-[left] ease-in-out delay-300 duration-500 overflow-y-scroll`}
			>
				<div className="flex flex-col h-[100%] justify-center">
					<ul
						className={`flex flex-col justify-center items-center mb-10 ${
							isOpen ? "opacity-100" : "opacity-0"
						} transition-all ease-in-out delay-700 duration-500`}
					>
						{navRoutes(intl).map((route) => (
							<li key={route.path} onClick={() => setIsOpen(!isOpen)}>
								<a
									href={route.path}
									className={`py-4 block ${
										activeSection === route.path ? "font-bold text-accent" : ""
									} transition ease-in-out delay-400 hover:font-bold`}
								>
									{route.label}
								</a>
							</li>
						))}
					</ul>
					<div
						className={`w-full flex justify-center items-center ${
							isOpen ? "opacity-100" : "opacity-0"
						} transition-all ease-in-out delay-700 duration-500`}
					>
						<a
							href="https://www.facebook.com/gt.efektivos"
							target="_blank"
							rel="noreferrer"
							className="flex items-center justify-center w-10 h-10 rounded-full bg-primary text-white hover:bg-accent transition-all duration-300 hover:scale-110 mr-3"
							aria-label="Facebook"
						>
							<svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
								<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
							</svg>
						</a>
						<a
							href="https://www.instagram.com/efektivos/?hl=es"
							target="_blank"
							rel="noreferrer"
							className="flex items-center justify-center w-10 h-10 rounded-full bg-primary text-white hover:bg-accent transition-all duration-300 hover:scale-110 mr-3"
							aria-label="Instagram"
						>
							<svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
								<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
							</svg>
						</a>
						<div
							className="w-[35px] h-[35px] relative"
							id="flag-icon-container"
						>
							<img
								className="w-full h-full rounded-full object-cover cursor-pointer"
								src={flag}
								alt={text}
								onClick={() => handleOnClick("toggle-mb-country")}
								id="flag-icon"
							/>
							<div
								id="toggle-mb-country"
								className={`bg-white shadow-lg absolute flex flex-col px-2 rounded-br-xl rounded-bl-xl top-full -left-1.5 overflow-hidden h-0`}
							>
								{countriesList.map((country) => (
									<div className="w-[35px] h-[35px] my-2" key={country.uid}>
										<img
											src={country.flag_url}
											alt={country.name}
											className="w-full h-full rounded-full object-cover cursor-pointer"
											onClick={() => {
												setIsOpen(!isOpen);
												handleOnSelectChange(country.country_code);
											}}
										/>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
